export const TOPIC_MARKET_NONE_CODE = 'none' as const;

export const TOPIC_MARKET_COUNTRIES = [
  { code: TOPIC_MARKET_NONE_CODE, label: 'بدون بازار' },
  { code: 'ir', label: 'ایران' },
  { code: 'us', label: 'آمریکا' },
  { code: 'gb', label: 'بریتانیا' },
  { code: 'de', label: 'آلمان' },
  { code: 'fr', label: 'فرانسه' },
  { code: 'ae', label: 'امارات' },
  { code: 'sa', label: 'عربستان' },
  { code: 'tr', label: 'ترکیه' },
  { code: 'ca', label: 'کانادا' },
  { code: 'au', label: 'استرالیا' },
  { code: 'in', label: 'هند' },
  { code: 'es', label: 'اسپانیا' },
] as const;

export type TopicMarketCountryCode = (typeof TOPIC_MARKET_COUNTRIES)[number]['code'];

export const DEFAULT_TOPIC_MARKET_COUNTRY: TopicMarketCountryCode = 'ir';

export function hasTopicMarketScope(code: string): boolean {
  if (code === 'global') return false;
  return code !== TOPIC_MARKET_NONE_CODE;
}

export function getTopicMarketCountryLabel(code: string): string {
  const normalized = code === 'global' ? TOPIC_MARKET_NONE_CODE : code;
  return TOPIC_MARKET_COUNTRIES.find((c) => c.code === normalized)?.label ?? code;
}
